"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelValidator = void 0;
var LabelValidator = exports.LabelValidator = {
  text: function text(v) {
    return v.length >= 1 && v.length <= 64;
  },
  color: function color(v) {
    return /^#\w{3,6}$/g.test(v) || /^\w{3,6}$/g.test(v);
  }
};